// Romanian translations
export const ro = {
  // App
  appName: 'CarTrip',
  signIn: 'Conectare',
  signUp: 'Înregistrare',
  signOut: 'Deconectare',
  email: 'E-mail',
  password: 'Parolă',
  fullName: 'Nume Complet',
  
  // Navigation
  home: 'Acasă',
  profile: 'Profil',
  settings: 'Setări',
  menu: 'Meniu',
  analytics: 'Analiză',
  
  // Trips
  myTrips: 'Călătoriile Mele',
  newTrip: 'Călătorie Nouă',
  selectTrip: 'Selectați Călătoria',
  tripName: 'Numele Călătoriei',
  createTrip: 'Creați Călătorie',
  deleteTrip: 'Ștergeți Călătoria',
  stops: 'opriri',
  tripHistory: 'Istoricul Călătoriilor',
  
  // Stops
  addStop: 'Adăugați Oprire',
  editStop: 'Editați Oprirea',
  deleteStop: 'Ștergeți Oprirea',
  noStops: 'Fără opriri',
  
  // Stop types
  city: 'Oraș',
  gasStation: 'Stație de Benzină',
  evCharging: 'Încărcare EV',
  restaurant: 'Restaurant',
  hotel: 'Hotel',
  attraction: 'Atracție',
  parking: 'Parcare',
  other: 'Altele',
  
  // Common
  cancel: 'Anulare',
  delete: 'Ștergere',
  close: 'Închidere',
  save: 'Salvare',
  search: 'Căutare',
  loading: 'Se încarcă...',
}
